{
  "name": "@xiboplayer/cache",
  "version": "0.7.23",
  "description": "Offline caching and download management with parallel chunk downloads",
  "type": "module",
  "main": "./src/index.js",
  "types": "./src/index.d.ts",
  "exports": {
    ".": "./src/index.js",
    "./cache": "./src/cache.js",
    "./store-client": "./src/store-client.js",
    "./download-manager": "./src/download-manager.js",
    "./cache-analyzer": "./src/cache-analyzer.js",
    "./widget-html": "./src/widget-html.js"
  },
  "scripts": {
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage"
  },
  "dependencies": {
    "@xiboplayer/utils": "workspace:*",
    "spark-md5": "^3.0.2"
  },
  "devDependencies": {
    "jsdom": "^29.0.2",
    "vitest": "^4.1.2"
  },
  "keywords": [
    "xibo",
    "digital-signage",
    "cache",
    "offline",
    "download",
    "indexeddb"
  ],
  "author": "Pau Aliagas <linuxnow@gmail.com>",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/xibo-players/xiboplayer.git",
    "directory": "packages/cache"
  },
  "homepage": "https://xiboplayer.org"
}
